import { useTheme } from '@mui/material/styles';

export default function CircleLogo({
  height = 96,
  width = 96
}: {
  height?: number;
  width?: number;
}) {
  const theme = useTheme();
  const brandColor = theme.palette.sidenav?.logoBrand ?? theme.palette.brand;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.01898 15.9944V11.4072C7.01915 8.42239 9.49676 5.82575 12.6209 5.82573C14.2943 5.82573 15.6685 6.7007 16.5842 7.83558C17.4953 8.96471 18.0367 10.4428 18.0367 11.8969V13.3948C18.0367 14.5953 18.7358 15.2484 19.6087 15.2484C20.4471 15.2484 21.1586 14.7073 21.4011 13.9586C21.4597 13.5388 21.4917 13.1098 21.4917 12.673V11.2746C21.4917 6.60132 17.6313 2.46995 13.0472 2.46995H12C6.75794 2.46995 2.50827 6.65471 2.50827 11.8167V12.1833C2.50827 17.3453 6.75794 21.5301 12 21.5301C14.2933 21.53 16.3936 20.7308 18.0343 19.3984C18.5686 18.9644 19.3591 19.0392 19.7998 19.5654C20.2404 20.0916 20.1645 20.87 19.6301 21.3039C17.5567 22.9877 14.8968 24 12 24C5.37267 24 0 18.7094 0 12.1833V11.8167C0 5.29059 5.37267 0 12 0H13.0472C19.1754 0 24 5.39903 24 11.2746V13.3948C24 13.7961 23.9436 14.1865 23.8383 14.558C23.3223 16.38 21.626 17.7184 19.6087 17.7184C17.017 17.7183 15.5285 15.606 15.5285 13.3948V11.8969C15.5285 11.0178 15.1897 10.0778 14.6203 9.37206C14.0555 8.67209 13.3489 8.29568 12.6209 8.29568C10.9427 8.2957 9.52742 9.72596 9.52725 11.4072V15.9944C9.5272 16.6764 8.96568 17.2293 8.27312 17.2293C7.58051 17.2293 7.01903 16.6764 7.01898 15.9944Z"
        fill={brandColor}
      />
    </svg>
  );
}
